import React from 'react';
import Button from '@sizeid/commons/components/Button';
import { INTEGRATION_INDEX } from '@sizeid/shared/constants/routes';
import { WithTranslation } from 'next-i18next';

import { withTranslation } from 'lib/i18n';

import { ImageList } from '../../../components/ImageList';
import { List } from '../../../components/ImageList/types';
import ShopifyLogo from '../images/shopify.png';
import ShoptetLogo from '../images/shoptet.png';
import FloxLogo from '../images/flox.png';
import FastLogo from '../images/fastcentrik.png';
import PrestaLogo from '../images/prestaShop.png';
import EshopRychleLogo from '../images/eshopRychle.png';
import ShopioLogo from '../images/shopio.png';

const platformList: List = [
  {
    id: 1,
    logo: ShopifyLogo,
    name: 'shopify',
    href: 'https://apps.shopify.com/sizeid',
    target: '_blank',
    internalLink: false,
  },
  {
    id: 2,
    logo: ShoptetLogo,
    name: 'shoptet',
    href: 'https://doplnky.shoptet.cz/sizeid-1',
    target: '_blank',
    internalLink: false,
  },
  {
    id: 4,
    logo: PrestaLogo,
    name: 'PrestaShop 1.7',
    href: 'integration',
    target: '_blank',
    internalLink: false,
  },
  {
    id: 5,
    logo: EshopRychleLogo,
    name: 'eshoprychle',
    href: 'https://helpdesk.eshop-rychle.cz/docs/aplikace/sizeid/',
    target: '_blank',
    internalLink: false,
  },
  {
    id: 6,
    logo: FastLogo,
    name: 'FASTCentrik',
    href: 'https://www.fastcentrik.cz/podpora/tipy-a-triky/sizeid',
    target: '_blank',
    internalLink: false,
  },
  {
    id: 7,
    logo: ShopioLogo,
    name: 'Shopio',
    href: 'integration',
    target: '_blank',
    internalLink: true,
  },
  {
    id: 8,
    logo: FloxLogo,
    name: 'Flox3',
    href: 'integration/files',
    target: '_blank',
    internalLink: true,
    params: { id: 'flox3' },
  },
];

const BusinessIntegration: React.FC<WithTranslation> = props => (
  <div>
    <ImageList square big list={platformList} />

    <Button
      link={INTEGRATION_INDEX.route}
      target="_blank"
      large
      outline
      css="margin-top: 5em"
    >
      {props.t('business.index.platforms.moreButton')}
    </Button>
  </div>
);

export default withTranslation('pages')(BusinessIntegration);
